import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceforcorporateeventsinmumbai() {



  const cardData =
  {
    keyword: ' Corporate Cab Services for Corporate Events in Mumbai',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services for Corporate Events in Mumbai',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Services for corporate events in Mumbai, ensuring seamless transportation for employees, clients, and top-level executives. Our fleet of executive sedans, SUVs, and premium vehicles guarantees comfortable, safe, and punctual travel for conferences, business meetings, seminars, product launches, and corporate gatherings. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, we deliver hassle-free and efficient mobility solutions that enhance the overall experience of your corporate events. Pune Corporate Cars India Private Limited ensures a premium and dependable travel service for businesses hosting events in and around Mumbai.',

    top: 'Top Places to Visit in Mumbai with Pune Corporate Car',

"topPlaces": [
    {
      "title": "Bandra Kurla Complex (BKC)",
      "description": "Bandra Kurla Complex is Mumbai’s premier financial and commercial district, home to multinational corporations, consulates, global banks, Fortune 500 headquarters, and luxury business hotels. The area includes iconic business towers such as Jio World Centre, Naman Chambers, and The Capital. BKC is the top hotspot for corporate meetings, high-profile events, executive travel, and airport transfers—making it one of the busiest destinations for corporate cab services."
    },
    {
      "title": "Lower Parel Corporate Hub",
      "description": "Lower Parel is Mumbai’s most dynamic corporate zone, combining high-rise office towers like One Indiabulls Centre, Peninsula Business Park, and Lodha World Towers. The area is filled with premium coworking spaces, studios, business hotels, and award-winning restaurants. With its mix of creative agencies, finance companies, and MNCs, Lower Parel demands fast, reliable corporate commuting throughout the day."
    },
    {
      "title": "Nariman Point Business District",
      "description": "Nariman Point is one of India’s oldest and most prestigious business districts, housing corporate headquarters, legal firms, government offices, and international consulates. Overlooking the Marine Drive seafront, it contains iconic commercial towers like Air India Building and Maker Chambers. High-density office traffic makes Nariman Point a prime route for corporate cab travel, especially during peak office hours."
    },
    {
      "title": "Andheri MIDC & SEEPZ",
      "description": "Andheri MIDC and SEEPZ SEZ are major industrial and tech zones in Mumbai, home to IT companies, export houses, manufacturing units, and global service providers. With thousands of employees working across multiple shifts, this zone witnesses high demand for employee transportation, shift-based staff travel, and corporate shuttle services throughout the day."
    },
    {
      "title": "Goregaon Nesco Business Park",
      "description": "Nesco IT Park in Goregaon East has become a major commercial destination with modern office towers, convention centers, and large corporate campuses. It hosts companies in IT, finance, BFSI, and media industries. Its proximity to the Western Express Highway and large employee base makes it one of the most active hubs for corporate cab requirements and executive travel."
    },
    {
      "title": "Powai Hiranandani Business District",
      "description": "Powai’s Hiranandani Business Park is a premium corporate environment featuring modern office complexes, luxury residences, and scenic surroundings. It hosts companies like Nomura, CRISIL, Deloitte, and JP Morgan. The area is known for high-end corporate travel, airport pickups, client meeting routes, and executive chauffeur services due to its professional working crowd."
    },
    {
      "title": "Vikhroli Godrej Business District",
      "description": "Vikhroli is home to the massive Godrej Business Park along with multiple commercial towers, IT campuses, and research facilities. Surrounded by greenery and located close to eastern business zones, it is a preferred location for tech firms and innovation centers. The daily movement of employees and corporate visitors creates consistent demand for premium mobility services."
    },
    {
      "title": "Andheri East Corporate Zone",
      "description": "Andheri East is Mumbai’s largest corporate cluster, packed with commercial towers like Solitaire Corporate Park, Ackruti Star, Times Square, and Hubtown Solaris. Its strategic location near Mumbai Airport makes it a hotspot for business travelers, frequent flyers, and client visits. Corporate cab services play a crucial role in daily commutes, airport drops, and inter-office travel."
    },
    {
      "title": "Malad Mindspace IT Park",
      "description": "Mindspace Malad is one of Mumbai’s biggest IT parks, hosting thousands of professionals working in tech, BPO, and corporate services. With companies like Amazon, Accenture, and JP Morgan operating here, the area runs round-the-clock mobility needs including daily office travel, night shift employee transportation, and executive cab services."
    },
    {
      "title": "Thane Ghodbunder Corporate Belt",
      "description": "Ghodbunder Road in Thane has rapidly grown into a major business corridor with IT parks, commercial complexes, and premium office towers. Corporate hubs like G:Corp, Orion Business Park, and TCS Olympus Centre bring huge employee footfall. It is well-connected to Mumbai, Navi Mumbai, and Thane, making it a high-demand route for corporate taxi and staff transportation services."
    }
  ],


"services": [
{
"name": "Event Transportation Mumbai",
"description": "Event Transportation Mumbai provides end-to-end travel solutions for corporate events, conferences, exhibitions, and large gatherings. The service includes well-maintained vehicles, professional drivers, GPS tracking, and optimized routes to ensure timely, safe, and organized transportation for staff, guests, and executives."
},
{
"name": "Corporate Event Shuttle Mumbai",
"description": "Corporate Event Shuttle Mumbai delivers structured shuttle services for employees, delegates, and participants attending corporate events. The service features multi-passenger vans, trained drivers, GPS-enabled vehicles, scheduled pick-ups and drop-offs, and multi-location coordination to ensure smooth and efficient commuting."
},
{
"name": "Business Conference Cab Mumbai",
"description": "Business Conference Cab Mumbai provides professional taxi services for delegates, executives, and staff attending corporate conferences. The service includes trained chauffeurs, GPS tracking, punctual pickups, and comfortable sedans and SUVs for a seamless travel experience."
},
{
"name": "Exhibition Staff Transport Mumbai",
"description": "Exhibition Staff Transport Mumbai offers reliable transportation solutions for exhibition staff and event teams. The service includes multi-passenger vehicles, structured routes, GPS monitoring, trained drivers, and timely pick-ups and drop-offs to ensure smooth event operations."
},
{
"name": "Corporate Meeting Fleet Mumbai",
"description": "Corporate Meeting Fleet Mumbai provides dedicated fleet services for corporate meetings, seminars, and boardroom events. The service includes sedans, SUVs, and buses with professional chauffeurs, GPS tracking, scheduled pickups, and optimized routing for punctual and organized transport."
},
{
"name": "VIP Event Cab Service Mumbai",
"description": "VIP Event Cab Service Mumbai delivers premium chauffeur-driven vehicles for VIP guests, executives, and dignitaries attending events. The service ensures luxury cars, trained drivers, GPS tracking, discreet service, and on-time pick-ups and drop-offs for a seamless and comfortable experience."
},
{
"name": "Luxury Event Cars Mumbai",
"description": "Luxury Event Cars Mumbai offers high-end cars for corporate events, weddings, product launches, and VIP transportation. The service includes well-maintained luxury sedans and SUVs, professional chauffeurs, GPS tracking, and timely service for a premium travel experience."
},
{
"name": "Executive Event Transport Mumbai",
"description": "Executive Event Transport Mumbai provides dedicated transportation for executives and top management attending corporate events. The service ensures punctual pickups, GPS-enabled vehicles, trained drivers, optimized routing, and comfortable travel in sedans and SUVs."
},
{
"name": "Best Event Travel Mumbai",
"description": "Best Event Travel Mumbai delivers top-quality event transportation services for corporate and large-scale events. The service includes professional drivers, well-maintained vehicles, GPS monitoring, structured schedules, and multi-passenger options to ensure efficient and safe transport."
},
{
"name": "Chauffeur Event Cars Mumbai",
"description": "Chauffeur Event Cars Mumbai offers professional chauffeur-driven vehicles for corporate, VIP, and high-profile event attendees. The service features luxury sedans and SUVs, GPS-enabled tracking, trained drivers, and punctual pickups for a premium and reliable travel experience."
},
{
"name": "Staff Movement Mumbai Events",
"description": "Staff Movement Mumbai Events provides organized transport for staff and volunteers working at corporate events, exhibitions, and conferences. The service includes multi-passenger vans, GPS tracking, trained drivers, and structured schedules to ensure timely and safe movement across event venues."
},
{
"name": "Large Group Corporate Travel Mumbai",
"description": "Large Group Corporate Travel Mumbai offers bulk transport solutions for corporate delegations, event teams, and conference attendees. The service features buses, vans, and multiple sedans with trained drivers, GPS monitoring, and well-coordinated schedules for smooth and efficient commuting."
},
{
"name": "Event Logistics Mumbai",
"description": "Event Logistics Mumbai provides comprehensive transportation and mobility solutions for corporate events, exhibitions, and large-scale gatherings. The service ensures timely staff and guest movement, vehicle coordination, professional drivers, and GPS-enabled vehicles for organized and hassle-free operations."
},
{
"name": "Corporate Bus & Cab Mumbai",
"description": "Corporate Bus & Cab Mumbai offers a mix of buses and corporate cabs for staff, delegates, and executives attending events. The service provides professional drivers, GPS tracking, structured routes, and flexible vehicle options to meet all corporate event transportation needs."
},
{
"name": "Premium Event Fleet Mumbai",
"description": "Premium Event Fleet Mumbai delivers high-end fleet solutions for VIPs, executives, and corporate delegates attending events. The service includes luxury sedans, SUVs, buses, trained drivers, GPS monitoring, and well-coordinated schedules for safe, comfortable, and professional transportation."
}
],

"tableData": [
["Event Transportation Mumbai", "Corporate Event Shuttle Mumbai"],
["Business Conference Cab Mumbai", "Exhibition Staff Transport Mumbai"],
["Corporate Meeting Fleet Mumbai", "VIP Event Cab Service Mumbai"],
["Luxury Event Cars Mumbai", "Executive Event Transport Mumbai"],
["Best Event Travel Mumbai", "Chauffeur Event Cars Mumbai"],
["Staff Movement Mumbai Events", "Large Group Corporate Travel Mumbai"],
["Event Logistics Mumbai", "Corporate Bus & Cab Mumbai"],
["Premium Event Fleet Mumbai", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services for Corporate Events in Mumbai",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services for events in Mumbai, ensuring smooth and timely transportation for employees, guests, and executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs, helping attendees reach corporate events, conferences, and business gatherings in Mumbai without any delays."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our skilled chauffeurs provide safe, courteous, and disciplined travel, ensuring comfortable and secure commuting for corporate guests and employees."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and equipped for safe and comfortable corporate event transportation."
  },
  {
    "WhyChooseheading": "Customized Event Travel Packages",
    "WhyChoosedescription": "We offer flexible cab rental plans tailored to meet the specific transportation needs of corporate events, ensuring seamless travel for large groups."
  },
  {
    "WhyChooseheading": "24/7 Event Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, route adjustments, and emergencies, guaranteeing uninterrupted travel during corporate events."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, providing secure and comfortable rides for employees and event guests."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate event transportation is streamlined through our simple booking process and reliable coordination, making travel hassle-free and stress-free."
  }
]

























  }

const faqData = [
  {
    question: 'Do you provide corporate cab services for corporate events in Mumbai?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for transporting guests and employees for corporate events in Mumbai.',
  },
  {
    question: 'What types of corporate event cab services are available?',
    answer: 'We provide event pickups and drops, shuttle services between venues, VIP transfers, airport transfers, and dedicated fleet solutions for corporate events.',
  },
  {
    question: 'Can you manage transportation for large corporate events?',
    answer: 'Yes, we can arrange multiple vehicles and optimized routes to handle large teams or guest groups efficiently during corporate events.',
  },
  {
    question: 'How can companies book corporate event cab services in Mumbai?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team for hassle-free event planning.',
  },
  {
    question: 'What types of vehicles are available for corporate events?',
    answer: 'We offer sedans, SUVs, luxury cars, Innova Crysta, tempo travellers, and mini buses depending on group size and event requirements.',
  },
  {
    question: 'Are chauffeurs provided for corporate event transportation?',
    answer: 'Yes, all vehicles come with professional and trained chauffeurs to ensure timely, safe, and comfortable travel for all guests and employees.',
  },
  {
    question: 'Do you provide real-time tracking and safety features?',
    answer: 'Absolutely. All vehicles are GPS-enabled, sanitized regularly, and driven by verified chauffeurs to maintain safety and punctuality.',
  },
  {
    question: 'Can you provide multi-venue transportation for corporate events?',
    answer: 'Yes, we coordinate multi-venue schedules, ensuring smooth and timely transfers between event locations in Mumbai.',
  },
  {
    question: 'What payment options are available for corporate event cab services?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide corporate invoicing for event organizers.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajat Singh',
    feedback: 'Professional and reliable cab service for our corporate event in Mumbai. Timely pickups and smooth operations.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ananya Mehta',
    feedback: 'Excellent service for corporate events. Drivers are professional and vehicles are comfortable and well-maintained.',
    rating: 5,
  },
];
































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services for Corporate Events in Mumbai",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-event-cab-mumbai.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides premium corporate cab services for events in Mumbai, including corporate event transportation, staff shuttle services, business conference cabs, exhibition staff transport, VIP and executive event cars, large group corporate travel, event logistics, and luxury chauffeur-driven vehicles for seamless corporate event mobility.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-corporate-events-mumbai"
  }
};




  return (
    <div>
<Helmet>
  <title>Corporate Cab Services for Corporate Events in Mumbai | Event & VIP Transport</title>

  <meta
    name="description"
    content="Premium corporate cab services for corporate events in Mumbai including event transportation, staff shuttles, business conference cabs, VIP and executive cars, exhibition staff transport, large group corporate travel, event logistics, and luxury chauffeur-driven vehicles."
  />

  <meta
    name="keywords"
    content="Event Transportation Mumbai, Corporate Event Shuttle Mumbai, Business Conference Cab Mumbai, Exhibition Staff Transport Mumbai, Corporate Meeting Fleet Mumbai, VIP Event Cab Service Mumbai, Luxury Event Cars Mumbai, Executive Event Transport Mumbai, Best Event Travel Mumbai, Chauffeur Event Cars Mumbai, Staff Movement Mumbai Events, Large Group Corporate Travel Mumbai, Event Logistics Mumbai, Corporate Bus & Cab Mumbai, Premium Event Fleet Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceforcorporateeventsinmumbai;